import { render, staticRenderFns } from "./NotificationsCenter.vue?vue&type=template&id=d820d0d8&"
import script from "./NotificationsCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationsCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports